// extracted by mini-css-extract-plugin
export default {"BannerContainer":"BannerContent_BannerContainer__8kgWR","ReadOnly":"BannerContent_ReadOnly__hy1zg","BannerContainer__Warning":"BannerContent_BannerContainer__Warning__-5OIc"};